// Mirrors impatasite/src/app/shared/password-strength/password-requirements.ts.
// The two apps share no workspace library (CLAUDE.md §13), so this is a deliberate copy.
// Keep the two files identical — the password experience is meant to match across apps.

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;

// Requires lowercase, uppercase, digit and special character; no whitespace.
export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]+$/;

export interface PasswordRequirement {
  label: string;
  met: boolean;
}

export function evaluatePasswordRequirements(password: string): PasswordRequirement[] {
  const value = password || '';
  return [
    { label: `At least ${PASSWORD_MIN_LENGTH} characters`, met: value.length >= PASSWORD_MIN_LENGTH },
    { label: 'One uppercase letter', met: /[A-Z]/.test(value) },
    { label: 'One lowercase letter', met: /[a-z]/.test(value) },
    { label: 'One number', met: /\d/.test(value) },
    { label: 'One special character', met: /[\W_]/.test(value) },
  ];
}

export function getPasswordScore(password: string): number {
  const value = password || '';
  if (!value) return 0;
  const requirements = evaluatePasswordRequirements(value);
  let score = requirements.filter(r => r.met).length;
  if (value.length >= 12) score += 1;
  return Math.min(score, 6);
}

export function getPasswordStrengthLabel(score: number): string {
  switch (true) {
    case score <= 1: return 'Very Weak';
    case score === 2: return 'Weak';
    case score === 3: return 'Medium';
    case score === 4: return 'Strong';
    default: return 'Very Strong';
  }
}
